import { combineReducers } from 'redux'
import globalReducer from './global_reducer'

export default combineReducers({
    globalReducer
})